import { useContext } from 'react';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import { FreezeIcon } from '../../../assets/icons/icons';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import BottomActionButton from '../../shared/BottomActionButton/BottomActionButton';
import BottomSheet from '../../shared/BottomSheet/BottomSheet';
import './FreezeCardSheet.css';

function FreezeCardSheet({ cardNumber, isSubmitting = false, onConfirm, onCancel }) {
  const { card, common, t } = useContext(TranslationContext);

  return (
    <BottomSheet
      className="freeze-card-sheet"
      panelClassName="freeze-card-sheet__panel"
      titleId="freeze-card-sheet-title"
      isDismissible={!isSubmitting}
      onClose={onCancel}
    >
      <div className="freeze-card-sheet__content">
        <span className="freeze-card-sheet__icon" aria-hidden="true">
          <FreezeIcon className="freeze-card-sheet__icon-svg" />
        </span>
        <h2 id="freeze-card-sheet-title" className="freeze-card-sheet__title">
          {card.freezeQuestion}
        </h2>
        <p className="freeze-card-sheet__text">
          {t('card.freezeText', { cardNumber })}
        </p>
      </div>

      <BottomActionButton
        className="freeze-card-sheet__confirm"
        disabled={isSubmitting}
        aria-busy={isSubmitting}
        onClick={onConfirm}
      >
        {isSubmitting ? (
          <MiniPreloader
            className="freeze-card-sheet__loader"
            label={common.loading}
          />
        ) : card.freezeAction}
      </BottomActionButton>
    </BottomSheet>
  );
}

export default FreezeCardSheet;
